// ตารางเส้นทางทั้งหมด (ตาม SPEC) — เพิ่มหน้าใหม่ที่นี่ที่เดียว
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import { RequireAuth } from "./components/guards";
import AppShell from "./components/layout/AppShell";
import Landing from "./pages/Landing";
import Home from "./pages/Home";
import Search from "./pages/Search";
import Character from "./pages/Character";
import Chat from "./pages/Chat";
import Create from "./pages/Create";
import Universe from "./pages/Universe";
import Creator from "./pages/Creator";
import Ranking from "./pages/Ranking";
import Feed from "./pages/Feed";
import Shorts from "./pages/Shorts";
import Coins from "./pages/Coins";
import Club from "./pages/Club";
import Rewards from "./pages/Rewards";
import Notifications from "./pages/Notifications";
import Me from "./pages/Me";
import Settings from "./pages/Settings";
import NotFound from "./pages/NotFound";
import { AdminLayout, AdminHome, AdminUsers, AdminCharacters, AdminTags, AdminPackages, AdminVip, AdminPromos, AdminModels, AdminGifts, AdminReports, AdminTopups, AdminSettings, AdminPlaceholder } from "./pages/admin/Admin";
import { RequireSuperUser } from "./components/guards";

/** "/" : ยังไม่ล็อกอิน = Landing, ล็อกอินแล้ว = เข้า shell ปกติ ; อื่น ๆ ต้องล็อกอิน + ยอมรับข้อกำหนด */
export function ShellRoute() {
  const { isLoggedIn } = useAuth();
  const { pathname } = useLocation();
  if (!isLoggedIn && pathname === "/") return <Landing />;
  return (
    <RequireAuth>
      <AppShell />
    </RequireAuth>
  );
}

export const shellRoutes = [
  { index: true, element: <Home /> },
  { path: "search", element: <Search /> },
  { path: "c/:id", element: <Character /> },
  { path: "chat", element: <Chat /> },
  { path: "chat/:chatId", element: <Chat /> },
  { path: "create", element: <Create /> },
  { path: "universe/:id", element: <Universe /> },
  { path: "creator/:id", element: <Creator /> },
  { path: "ranking", element: <Ranking /> },
  { path: "feed", element: <Feed /> },
  { path: "shorts", element: <Shorts /> },
  { path: "coins", element: <Coins /> },
  { path: "club", element: <Club /> },
  { path: "rewards", element: <Rewards /> },
  { path: "notifications", element: <Notifications /> },
  { path: "me", element: <Me /> },
  { path: "settings", element: <Settings /> },
  {
    path: "admin",
    element: <RequireSuperUser><AdminLayout /></RequireSuperUser>,
    children: [
      { index: true, element: <AdminHome /> },
      { path: "users", element: <AdminUsers /> },
      { path: "characters", element: <AdminCharacters /> },
      { path: "tags", element: <AdminTags /> },
      { path: "packages", element: <AdminPackages /> },
      { path: "vip", element: <AdminVip /> },
      { path: "promos", element: <AdminPromos /> },
      { path: "models", element: <AdminModels /> },
      { path: "gifts", element: <AdminGifts /> },
      { path: "reports", element: <AdminReports /> },
      { path: "topups", element: <AdminTopups /> },
      { path: "settings", element: <AdminSettings /> },
      { path: "*", element: <AdminPlaceholder /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export const NavigateHome = () => <Navigate to="/" replace />;
